import styled, { keyframes } from 'styled-components';

const flyInAnimation = keyframes`
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  position: relative;
  top: 20px;
  margin-left: 4rem;
  margin-right: 1rem;
  margin-bottom: 6rem;
  height: 100%;
`;

export const SpeechBubbleRobot = styled.div<{ $delay: number }>`
  background-color: var(--color-highlight-lightest);
  border-radius: 10px;
  padding: 1.5rem;
  position: relative;
  max-width: 100%;
  opacity: 0;
  transform: translateY(30px);
  animation: ${flyInAnimation} 0.8s ease-out forwards;
  animation-delay: ${(props) => props.$delay}s;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 1.6rem;
`;

export const Text = styled.div`
  margin-top: 0.5rem;
  font-size: 1.3rem;
`;

export const ButtonContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  flex-direction: column;
  max-width: 18.75rem;
  & > button {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    height: 100%;
  }
`;
